import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-xl font-semibold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
      {title}
    </h2>
    <div className="text-sm sm:text-base text-muted-foreground leading-relaxed space-y-2">
      {children}
    </div>
  </section>
);

const PrivacyPolicyPage = () => (
  <main className="min-h-screen bg-background text-foreground">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8 transition-colors duration-150">
        <ArrowLeft className="w-4 h-4" />
        Back to Home
      </Link>

      <header className="mb-10 border-b border-border pb-8">
        <div className="flex items-center gap-3 mb-4">
          <Shield className="w-8 h-8 text-primary" />
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-muted-foreground">SecureVault</span>
        </div>
        <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Privacy Policy
        </h1>
        <p className="text-sm text-muted-foreground mt-3">Last updated: May 2025</p>
      </header>

      <div className="space-y-8">
        <Section title="About SecureVault">
          <p>
            SecureVault is available at vault.priyanshurathod.com and is an individual project by Priyanshu Rathod, Dehradun, India.
          </p>
        </Section>

        <Section title="What Data We Collect">
          <p>We collect the minimum information needed to operate the service:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Email address</li>
            <li>File names</li>
            <li>File sizes</li>
            <li>Upload timestamps</li>
            <li>IP addresses in logs</li>
          </ul>
        </Section>

        <Section title="What We Do Not Collect">
          <ul className="list-disc pl-5 space-y-1">
            <li>We do not collect readable file contents. Files are AES-256-GCM encrypted client-side before upload, so we cannot read them.</li>
            <li>We do not store plaintext passwords. Passwords are bcrypt hashed before storage.</li>
          </ul>
        </Section>

        <Section title="How We Use Data">
          <p>We use collected data for authentication, service operation, and security monitoring.</p>
        </Section>

        <Section title="Data Storage">
          <p>
            SecureVault uses Supabase for PostgreSQL database services and file storage. The Supabase project is hosted in the EU region.
          </p>
        </Section>

        <Section title="Data Retention">
          <p>We retain account and file metadata until account deletion.</p>
        </Section>

        <Section title="User Rights">
          <p>You have the right to delete your account and all associated data, and the right to export your data.</p>
        </Section>

        <Section title="Third Party Services">
          <p>SecureVault uses Supabase, Vercel, Cloudflare, and Resend to provide hosting, storage, authentication, delivery, and email functionality.</p>
        </Section>

        <Section title="Contact">
          <p>
            For privacy questions, contact <a href="mailto:security@priyanshurathod.com" className="text-primary hover:underline">security@priyanshurathod.com</a>.
          </p>
        </Section>
      </div>
    </div>
  </main>
);

export default PrivacyPolicyPage;
